import { Form, Input } from "decorator-form";
import InputType from "../../form/InputType";

@Form({title: "Seperator View Config"})
export default class SeparatorViewConfig {

	public spacing: number = 15;

	@Input({type: InputType.UNIT, title: "Vertical Spacing"})
	public height: string;

	@Input({type: InputType.UNIT, title: "Horizontal Spacing"})
	public width: string;

	// style - line

}



// WEBPACK FOOTER //
// ./src/common/views/separator/SeparatorViewConfig.ts